//@flow

import React from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import { POLL_TAGS, isFeatureEnabled } from '../../stores/featureFlags'
import { isAdmin } from '../../stores/usersStore'
import { selectCurrentUser } from '../../stores/currentUser'

type Props = {
  className?: string,
  options: Array<Object>,
  onChange: Function,
  value: any,
  isAdmin: boolean,
  pollTagsEnabled: boolean,
}

const TagsSelect = ({
  className = '',
  options,
  onChange,
  value,
  isAdmin,
  pollTagsEnabled,
}: Props) => {
  if (!isAdmin && !pollTagsEnabled) return null

  return (
    <Select
      className={`${className}`}
      options={options}
      multi={true}
      onChange={onChange}
      value={value}
      placeholder="Select tags"
    />
  )
}

const mapStateToProps = state => {
  const user = selectCurrentUser(state)
  const isAdminUser = user ? isAdmin(user) : null
  return {
    isAdmin: isAdminUser,
    pollTagsEnabled: isFeatureEnabled(POLL_TAGS)(state),
  }
}

export default connect(mapStateToProps)(TagsSelect)



// WEBPACK FOOTER //
// ./src/components/PollForm/TagsSelect.js